"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Path = void 0;
var react_1 = __importDefault(require("react"));
var utils_1 = require("../utils");
var Path = function (_a) {
    var data = _a.data, _b = _a.pathVariables, onClick = _b.onClick, rx = _b.rx, ry = _b.ry, height = _b.height, ir = _b.ir, fixed = _b.fixed, moveDistance = _b.moveDistance, moveElement = _b.moveElement, showTooltips = _b.showTooltips, stroke = _b.stroke, strokeWidth = _b.strokeWidth, tooltipShowName = _b.tooltipShowName, tooltipShowPercentage = _b.tooltipShowPercentage, tooltipShowValue = _b.tooltipShowValue, type = _a.type;
    var handleOnClick = function () {
        moveElement(data.startAngle);
        onClick(data.index);
    };
    var createPath = function () {
        switch (type) {
            case 'end':
                return (0, utils_1.createEndWallPath)(data.endAngle, rx, ry, height, ir);
            case 'inner':
                return (0, utils_1.createInnerPath)(data.startAngle, data.endAngle, rx, ry, height, ir);
            case 'outer':
                return (0, utils_1.createOuterPath)(data.startAngle, data.endAngle, rx, ry, height);
            case 'start':
                return (0, utils_1.createStartWallPath)(data.startAngle, rx, ry, height, ir);
            case 'top':
                return (0, utils_1.createTopPath)(data.startAngle, data.endAngle, rx, ry, ir);
            default:
                throw Error('No such path type');
        }
    };
    var styles = { fill: data.color, cursor: 'pointer' };
    var label = data.label !== undefined ? data.label : '';
    var tooltipName = tooltipShowName && label !== undefined ? "".concat(label, " ") : '';
    var tooltipText = "".concat(tooltipName).concat(tooltipShowValue ? ":\n".concat(data.value) : '') +
        "".concat(tooltipShowPercentage ? ":\n".concat((data.percentageValue * 100).toFixed(fixed), "%") : '');
    var transformation = data.moved
        ? "translate(".concat((0, utils_1.getNewPosition)(data.middleAngle, rx, ry, moveDistance).join(','), ")")
        : 'translate(0,0)';
    return (react_1.default.createElement("path", { d: createPath(), onClick: handleOnClick, stroke: stroke, strokeWidth: strokeWidth, style: styles, transform: transformation }, showTooltips && react_1.default.createElement("title", { className: "chart-tooltip" }, tooltipText)));
};
exports.Path = Path;
